import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const isSendingEmailReceipt = createSelector(onlineOrderState, (onlineOrder) => onlineOrder.sendEmailReceipt.isSending);
